/**
 * Header functionality for AI Search page - Vanilla JS (No jQuery)
 * Converted from medscape-library.js to remove jQuery dependency
 */

(function() {
    'use strict';

    // ============================================================================
    // HEADER SEARCH TYPEAHEAD LOGIC
    // ============================================================================
    
    var dataCopy;
    var textCopy;
    var typedInputNew = "";
    var combolimit = 0;
    var keyBlurFlg = false;

    if (typeof window.getDomain !== 'function') {
        window.getDomain = function(profreg) {
            var _domain = "";
            if (window.location.host.split('.').length == 4) {
                _domain = window.location.host.split('.')[1] + ".";
            }
            if (window.location.host.split('.').length == 5) {
                _domain = window.location.host.split('.')[1] + "." + window.location.host.split('.')[2] + ".";
            }
            if (profreg == "profreg" || profreg == "login") {
                _domain = _domain.replace('staging.', '').replace('proddev.', '');
            }
            return _domain;
        };
    }

    function closeil(elem) {
        if (!keyBlurFlg) {
            if (navigator.userAgent.toLowerCase().match(/msie 8/) != null) {
                if (this.value == '') {
                    this.style.color = '#999';
                    this.value = this.getAttribute('placeholder');
                }
            }
            if (typeof elem.innerHTML != 'undefined') {
                setTimeout(function() {
                    var ilfulllist = elem.querySelector('.ilfulllist');
                    if (ilfulllist) {
                        ilfulllist.style.display = 'none';
                    }
                    elem.classList.remove('lookup-open');
                }, 300);
            } else {
                var self = this;
                if (self.tagName != 'FORM') {
                    self = self.closest('form');
                }
                setTimeout(function() {
                    var ilfulllist = self.querySelector('.ilfulllist');
                    if (ilfulllist) {
                        ilfulllist.style.display = 'none';
                    }
                    self.classList.remove('lookup-open');
                }, 300);
            }
            setTimeout(function() {
                window.addEventListener('scroll', gHdrScrl);
            }, 300);
        }
        keyBlurFlg = false;
    }

    function openil() {
        var parForm = this.closest('form');
        
        parForm.classList.add('lookup-open');
        
        parForm.removeEventListener('reset', closeil);
        parForm.addEventListener('reset', closeil);
        
        window.removeEventListener('scroll', gHdrScrl);

        if (navigator.userAgent.toLowerCase().match(/msie 8/) != null) {
            if (this.value == this.getAttribute('placeholder')) {
                this.style.color = '#000';
                this.value = '';
            }
        }

        if (this.value.length >= 3 && parForm.querySelector('.ilfulllist')) {
            instantlook(this);
        }
    }

    function ilArrowNav(event) {
        if (event.keyCode == 40 || event.keyCode == 9 && this.nextElementSibling && this.nextElementSibling.classList.contains('ilfulllist') && this.nextElementSibling.style.display !== 'none') {
            if (event.keyCode == 9) {
                keyBlurFlg = true;
            } else if (event.keyCode == 40) {
                event.preventDefault();
            }
            var par = this.closest('form');
            var comboLinks = par.querySelectorAll('.combolist li a');
            
            comboLinks.forEach(function(link) {
                link.removeEventListener('blur', handleBlur);
                link.addEventListener('blur', handleBlur);
                
                link.removeEventListener('focus', handleFocus);
                link.addEventListener('focus', handleFocus);
                
                link.removeEventListener('mouseenter', handleHover);
                link.addEventListener('mouseenter', handleHover);
                
                link.removeEventListener('keydown', handleKeydown);
                link.addEventListener('keydown', handleKeydown);
            });

            function handleBlur(e) {
                setTimeout(function() {
                    var activeEl = document.activeElement;
                    if (!activeEl.closest('form') || (typeof activeEl.type != 'undefined' && activeEl.type == 'submit') || activeEl.closest('form') != par) {
                        keyBlurFlg = false;
                        closeil(par);
                    }
                }, 10);
            }

            function handleFocus() {
                var focused = document.querySelector('.focused');
                if (focused) {
                    focused.classList.remove('focused');
                }
                this.parentElement.classList.add('focused');
            }

            function handleHover() {
                this.focus();
            }

            function handleKeydown(e) {
                if (e.keyCode != 9) {
                    e.preventDefault();
                } else if (e.keyCode == 9 && this.parentElement.nextElementSibling === null) {
                    e.preventDefault();
                    var searchInput = this.closest('form').querySelector('.search-input');
                    if (searchInput) {
                        searchInput.focus();
                    }
                }
                if (e.keyCode == 40 || e.keyCode == 39) {
                    if (this.parentElement.nextElementSibling) {
                        var nextLink = this.parentElement.nextElementSibling.querySelector('a');
                        if (nextLink) {
                            nextLink.focus();
                        }
                    }
                } else if (this.parentElement.previousElementSibling === null && (e.keyCode == 38 || e.keyCode == 37)) {
                    var focused = document.querySelector('.focused');
                    if (focused) {
                        focused.classList.remove('focused');
                    }
                    var searchInput = this.closest('form').querySelector('.search-input');
                    if (searchInput) {
                        searchInput.focus();
                    }
                } else if (e.keyCode == 38 || e.keyCode == 37) {
                    if (this.parentElement.previousElementSibling) {
                        var prevLink = this.parentElement.previousElementSibling.querySelector('a');
                        if (prevLink) {
                            prevLink.focus();
                        }
                    }
                } else if (e.keyCode == 13 || e.keyCode == 32) {
                    var searchInput = this.closest('form').querySelector('.search-input');
                    if (searchInput) {
                        searchInput.value = this.innerHTML.replace(/<[^>]+>/g, '');
                    }
                    var ilfulllist = this.closest('form').querySelector('.ilfulllist');
                    if (ilfulllist) {
                        ilfulllist.style.display = 'none';
                    }
                    if (typeof this.getAttribute('onclick') != 'undefined') {
                        eval(this.getAttribute('onclick'));
                    }
                    if (typeof this.getAttribute('href') != 'undefined' && this.getAttribute('href').indexOf('javascript') == -1) {
                        window.location.href = this.getAttribute('href');
                    }
                }
            }

            if (event.keyCode == 40) {
                keyBlurFlg = true;
                var firstLink = par.querySelector('.combolist li a');
                if (firstLink) {
                    firstLink.focus();
                }
            }
        }
    }

    function il_call() {
        var parForm = this.closest('form');
        if (parForm.querySelector('.ilfulllist')) {
            if (this.value.length >= 3) {
                instantlook(this);
            } else {
                var ilfulllist = parForm.querySelector('.ilfulllist');
                if (ilfulllist) {
                    ilfulllist.style.display = 'none';
                }
            }
        }
    }

    function instantlook(context) {
        typedInputNew = context.value.replace(/&/g, "\\&").replace(/\+/g, "\\+").replace(/\(/g, "\\(").replace(/\)/g, "\\)").replace(/#/g, "\\#").replace(/\//g, "\\/").replace(/'/g, "\\'");

        if (typedInputNew.length == 0) {
            var combolist = context.closest('form').querySelector(".combolist");
            if (combolist) {
                combolist.innerHTML = "";
            }
            combolimit = 0;
        } else if (context.value == textCopy) {
            showResults(dataCopy, context, context.value);
        } else {
            var text = context.value;
            textCopy = text;
            text = text.replace(/&/g, "\\&").replace(/\+/g, "\\+").replace(/\(/g, "\\(").replace(/\)/g, "\\)").replace(/#/g, "\\#").replace(/\//g, "\\/").replace(/'/g, "\\'");

            var envDomain = document.domain.indexOf('.dev') != -1 ? 'devint.' : document.domain.indexOf('.qa') != -1 ? 'qa.' : '';

            var lookupAbortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            var lookupTimeout = lookupAbortController ? setTimeout(function() {
                lookupAbortController.abort();
            }, 1000) : null;

            fetch('//www.' + envDomain + 'webmd.com/api/qrl/LookupService.ashx?q=' + text + '&sz=5&s=10001&namespace=medscape', {
                method: 'GET',
                headers: {
                    'accept': 'application/json'
                },
                signal: lookupAbortController ? lookupAbortController.signal : undefined
            })
            .then(function(response) {
                if (lookupTimeout) {
                    clearTimeout(lookupTimeout);
                }
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then(function(data) {
                showResults(data, context, text);
            })
            .catch(function(error) {
                if (lookupTimeout) {
                    clearTimeout(lookupTimeout);
                }
                console.error('Typeahead fetch error:', error);
            });
        }
    }

    function showResults(data, context, query) {
        dataCopy = data;
        var combolist = context.closest('form').querySelector(".combolist");
        if (combolist) {
            combolist.innerHTML = "";
        }
        
        if (typeof data != 'undefined' && typeof data.types != 'undefined' && data.types.length >= 1) {
            for (var i = 0; i < data.types[0].references.length; i++) {
                var resultline = document.createElement("li");
                var ilOmniPre;
                
                if (document.domain.match('search') != null) {
                    if (context.closest('form').getAttribute('id') == 'SearchFormHeader') {
                        ilOmniPre = "hd-sr-srch_la";
                    } else {
                        ilOmniPre = "main-srch_la";
                    }
                } else {
                    ilOmniPre = "hd-sr-srch_il";
                }
                
                var plr = "";
                if (document.domain.match('search') != null && window.location.href.match('&plr=') != null) {
                    plr = window.location.href.match(/&plr=[^&]+/)[0];
                } else if (document.getElementById('searchdbvalue') && document.getElementById('searchdbvalue').value == "3") {
                    plr = "&plr=edu";
                }
                
                var queryRx = new RegExp("(" + query + ")", "ig");
                var domain = '';
                if (typeof getDomain === 'function') {
                    domain = getDomain('profreg');
                } else if (typeof getHeliosDomain === 'function') {
                    domain = getHeliosDomain(false);
                } else {
                    domain = document.domain.indexOf('.dev') != -1 ? 'devint.' : document.domain.indexOf('.qa') != -1 ? 'qa.' : '';
                }
                resultline.innerHTML = '<a href=\'//search.' + domain + 'medscape.com/search?q="' + data.types[0].references[i].text + '"' + plr + '\' onclick="wmdTrack(\'' + ilOmniPre + (i + 1) + '\')">' + data.types[0].references[i].text.replace(queryRx, '<span class="ta-hl">$1</span>') + '</a>';
                
                if (combolist) {
                    combolist.appendChild(resultline);
                }
                combolimit = combolimit + 1;
            }
        }
        
        var ilfulllist = context.closest('form').querySelector('.ilfulllist');
        if (combolimit > 0) {
            if (ilfulllist) {
                ilfulllist.style.display = 'block';
            }
        } else {
            if (ilfulllist) {
                ilfulllist.style.display = 'none';
            }
        }
        combolimit = 0;
    }

    function searchCp(site, callback, searchStr) {
        if (typeof callback == 'string') {
            searchStr = callback;
            callback = undefined;
        }

        var cpSrchData = {};
        cpSrchData.appname = 'search';
        cpSrchData.activityName = site;

        if (typeof searchStr != 'undefined') {
            cpSrchData.search = searchStr;
        } else {
            var searchInput = document.getElementById('search-input');
            cpSrchData.search = searchInput ? encodeURIComponent(searchInput.value) : '';
        }

        if (typeof segVarParam === 'function') {
            var metaSegVar = document.querySelector('meta[name="metasegvar"]');
            if (metaSegVar && segVarParam('artid') != '0') {
                cpSrchData.activityId = segVarParam('artid');
            }
        }

        if (typeof postCp === 'function') {
            postCp(cpSrchData, callback);
        } else if (typeof callback === 'function') {
            callback();
        }
    }

    function doSearch(locale, eduFlag) {
        var localeString = '';
        if (locale != null && locale != 'en') {
            localeString = '/' + locale;
        }

        var qval = '';
        var searchInputs = document.querySelectorAll('.search-input');
        searchInputs.forEach(function(input) {
            if (input.value != '') {
                qval = '"' + encodeURIComponent(input.value) + '"';
            }
        });

        if (qval == '""') {
            var layerSearchInput = document.getElementById('layer-search-input');
            qval = layerSearchInput ? encodeURIComponent(layerSearchInput.value) : '';
        }

        if (qval.indexOf('@') != -1) {
            qval = '';
        }

        var searchInput = document.getElementById('search-input');
        var searchInputAlt = document.getElementById('searchInput');
        var domain = typeof getDomain === 'function' ? getDomain('profreg') : '';

        if ((searchInput && searchInput.value == 'Search Medscape') || (searchInputAlt && searchInputAlt.value == 'Search Medscape')) {
            window.location.href = '//search.' + domain + 'medscape.com/search' + localeString;
        } else if (typeof eduFlag != 'undefined' && eduFlag == 'edu') {
            window.location.href = '//search.' + domain + 'medscape.com/search' + localeString + '/?q=' + qval + '&plr=edu';
        } else {
            window.location.href = 'http://search.' + domain + 'medscape.com/search' + localeString + '/?q=' + qval;
        }
    }

    function changeSeachDB(id, str) {
        var element = document.getElementById(id);
        if (element) {
            element.innerHTML = str;
        }
    }

    function subsearchheadertrack(locale) {
        var searchDbValue = document.getElementById('searchdbvalue');
        if (!searchDbValue) {
            return;
        }

        if (searchDbValue.value == '1') {
            if (typeof wmdTrack === 'function') {
                wmdTrack('hd-sr-srch');
            }
            searchCp('news', function() {
                doSearch(locale);
            });
        }
        if (searchDbValue.value == '2') {
            if (typeof wmdTrack === 'function') {
                wmdTrack('hd-sr-srch');
            }
            searchCp('reference', function() {
                doSearch(locale);
            });
        }
        if (searchDbValue.value == '3') {
            if (typeof wmdTrack === 'function') {
                wmdTrack('hd-sr-srch');
            }
            searchCp('education', function() {
                doSearch(locale, 'edu');
            });
        }
        if (searchDbValue.value == '4') {
            if (typeof wmdTrack === 'function') {
                wmdTrack('hd-sr-srch');
            }
            searchCp('medline', function() {
                doSearch(locale);
            });
        }
    }

    // ============================================================================
    // HEADER FUNCTIONALITY & EXPANSION
    // ============================================================================

    window.headerState = {
        sticky: false,
        visible: true,
        animating: false,
        expanded: false
    };

    var lastScrollTop = 0;
    var scrollThreshold = 3;
    var $header = null;
    var headerHeight = 0;

    function initExpandableSections() {
        var expandButtons = document.querySelectorAll('.js-expand-button');
        expandButtons.forEach(function(button) {
            button.addEventListener('click', function(event) {
                event.preventDefault();

                var sectionSelector = this.getAttribute('data-section');
                var targetSection = sectionSelector ? document.querySelector(sectionSelector) : null;
                if (targetSection) {
                    targetSection.classList.toggle('is-expanded');
                }

                var arrow = this.querySelector('.sp-arrow');
                if (arrow) {
                    arrow.classList.toggle('is-rotated');
                }

                if (this.classList.contains('mobile-edition-toggle') && typeof wmdPageLink !== 'undefined' && targetSection) {
                    if (targetSection.classList.contains('is-expanded')) {
                        wmdPageLink('hd-gl_langopen');
                    } else {
                        wmdPageLink('hd-gl_langclose');
                    }
                }
            });
        });
    }

    function initHeaderFunctionality() {
        $header = document.querySelector('.mscp-header');
        if (!$header) return;
        
        headerHeight = $header.offsetHeight;
        
        var headerRowBottom = document.querySelector('.header-row-bottom');
        if (headerRowBottom && headerRowBottom.classList.contains('active')) {
            window.headerState.expanded = true;
        }

        // Header search toggle
        if (headerRowBottom && headerRowBottom.classList.contains('active')) {
            var searchIcon = document.querySelector('.header-search-icon');
            if (searchIcon) {
                searchIcon.classList.add('active');
            }
            document.body.classList.add('hdr-expand');
        }

        var searchIcon = document.querySelector('.header-search-icon');
        if (searchIcon) {
            searchIcon.addEventListener('click', function() {
                window.removeEventListener('scroll', gHdrScrl);
                
                var mobileNavCheckbox = document.querySelector('#mobile-nav-checkbox');
                if (mobileNavCheckbox) {
                    mobileNavCheckbox.checked = false;
                }
                document.body.classList.remove("menuView");
                
                this.classList.toggle('active');
                var headerRowBottom = document.querySelector('.header-row-bottom');
                if (headerRowBottom) {
                    headerRowBottom.classList.toggle('active');
                }
                
                if (headerRowBottom && headerRowBottom.classList.contains('active')) {
                    document.body.classList.add('hdr-expand');
                } else {
                    document.body.classList.remove('hdr-expand');
                }
                
                setTimeout(function() {
                    if (window.headerState.sticky) {
                        if (headerRowBottom && headerRowBottom.classList.contains('active')) {
                            lastScrollTop = lastScrollTop + headerRowBottom.offsetHeight;
                        } else {
                            lastScrollTop = lastScrollTop - headerRowBottom.offsetHeight;
                        }
                        window.dispatchEvent(new CustomEvent('headerStateChange', {
                            detail: {
                                top: $header.offsetHeight
                            }
                        }));
                    }
                    window.addEventListener('scroll', gHdrScrl);
                }, 300);
            });
        }

        var mobileNavToggle = document.querySelector('.mobile-nav-toggle-label');
        if (mobileNavToggle) {
            mobileNavToggle.addEventListener('click', function() {
                var mobileNavCheckbox = document.querySelector('#mobile-nav-checkbox');
                if (mobileNavCheckbox && !mobileNavCheckbox.checked) {
                    var headerRowBottom = document.querySelector('.header-row-bottom');
                    var searchIcon = document.querySelector('.header-search-icon');
                    if (headerRowBottom) {
                        headerRowBottom.classList.remove('active');
                    }
                    if (searchIcon) {
                        searchIcon.classList.remove('active');
                    }
                    document.body.classList.remove('hdr-expand');
                }
            });
        }

        var userPopupTriggers = document.querySelectorAll('.user-links-settings, .user-popup');
        userPopupTriggers.forEach(function(trigger) {
            trigger.addEventListener('click', function(event) {
                event.stopPropagation();
                var userPopupMenu = document.querySelector('.user-popup-menu');
                if (userPopupMenu) {
                    userPopupMenu.classList.toggle('is-expanded');
                }
            });
        });

        document.addEventListener('click', function(event) {
            if (!event.target.closest('.user-popup-menu, .user-links-settings, .user-popup')) {
                var userPopupMenu = document.querySelector('.user-popup-menu');
                if (userPopupMenu) {
                    userPopupMenu.classList.remove('is-expanded');
                }
            }
        });

        var closePopupTabs = document.querySelectorAll('.header-tab--more, .header-edition');
        closePopupTabs.forEach(function(tab) {
            if (!tab.classList.contains('user-links')) {
                tab.addEventListener('click', function() {
                    var userPopupMenu = document.querySelector('.user-popup-menu');
                    if (userPopupMenu) {
                        userPopupMenu.classList.remove('is-expanded');
                    }
                });
            }
        });

        // Add 'selected' class to search div when search field is clicked
        var searchInputs = document.querySelectorAll('.search-input');
        searchInputs.forEach(function(input) {
            input.addEventListener('focus', function() {
                var parent = this.closest('.header-search, .mobile-menu-search');
                if (parent) {
                    parent.classList.add('selected');
                }
            });

            input.addEventListener('blur', function() {
                var parent = this.closest('.header-search, .mobile-menu-search');
                if (parent) {
                    parent.classList.remove('selected');
                }
            });

            // Bind typeahead events
            input.addEventListener('focus', openil);
            input.addEventListener('blur', closeil);
            input.addEventListener('keydown', ilArrowNav);
            input.addEventListener('keyup', il_call);
        });

        // Smart header scroll
        window.addEventListener('scroll', gHdrScrl);

        // Toggle more layer when clicking "More" link
        var headerMoreLink = document.querySelector('#header-more-link');
        if (headerMoreLink) {
            headerMoreLink.addEventListener('click', function(event) {
                this.classList.toggle('active');
                var moreLayer = document.querySelector('#header-more-layer');
                if (moreLayer) {
                    moreLayer.classList.toggle('show');
                }
                event.stopPropagation();
            });
        }

        // Close layer when clicking anywhere else on the page
        document.addEventListener('click', function(event) {
            var moreLayer = document.querySelector('#header-more-layer');
            var headerMoreLink = document.querySelector('#header-more-link');
            if (moreLayer && !event.target.closest('#header-more-layer') && moreLayer.classList.contains('show')) {
                moreLayer.classList.remove('show');
                if (headerMoreLink) {
                    headerMoreLink.classList.remove('active');
                }
            }
        });

        var headerTabs = document.querySelectorAll('.header-edition, .user-links');
        headerTabs.forEach(function(tab) {
            if (!tab.classList.contains('header-tab--more')) {
                tab.addEventListener('click', function() {
                    var moreLayer = document.querySelector('#header-more-layer');
                    var headerMoreLink = document.querySelector('#header-more-link');
                    if (moreLayer) {
                        moreLayer.classList.remove('show');
                    }
                    if (headerMoreLink) {
                        headerMoreLink.classList.remove('active');
                    }
                });
            }
        });

        initExpandableSections();

        // Footer tabs functionality
        initFooterTabs();
    }

    function handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var headerRowTop = document.querySelector('.header-row-top');

        if (scrollTop <= (headerRowTop ? headerRowTop.offsetHeight / 2 : 0)) {
            resetHeader();
            lastScrollTop = scrollTop;
            return;
        }

        if (Math.abs(scrollTop - lastScrollTop) < scrollThreshold) {
            lastScrollTop = scrollTop;
            return;
        }

        if (scrollTop > lastScrollTop) {
            // scrolling down
            if (scrollTop > headerHeight && window.headerState.visible) {
                hideHeader();
            }
        } else {
            // scrolling up
            if (scrollTop > headerHeight) {
                if (!window.headerState.sticky) {
                    prepareHeaderForAnimation();
                }
                if (!window.headerState.visible) {
                    showHeader();
                }
            }
        }

        lastScrollTop = scrollTop;
    }

    function resetHeader() {
        if (!$header) return;
        
        $header.classList.remove('slide-in', 'sticky', 'visible');
        document.body.classList.remove('hdr-stick');

        if (window.headerState.sticky) {
            window.dispatchEvent(new CustomEvent('headerStateChange', {
                detail: {
                    top: 0
                }
            }));
        }

        window.headerState.sticky = false;
        window.headerState.visible = true;
        window.headerState.animating = false;

        if (window.headerState.expanded) {
            var headerRowBottom = document.querySelector('.header-row-bottom');
            if (headerRowBottom) {
                headerRowBottom.classList.add('active');
            }
            document.body.classList.add('hdr-expand');
        }
    }

    function prepareHeaderForAnimation() {
        if (!$header) return;
        
        $header.classList.add('sticky');
        $header.offsetHeight; // force reflow
        $header.classList.add('slide-in');
        window.headerState.sticky = true;
        window.headerState.visible = false;
    }

    function showHeader() {
        if (!window.headerState.animating && $header) {
            window.headerState.animating = true;

            if (!$header.classList.contains('slide-in')) {
                $header.classList.add('slide-in');
            }

            $header.offsetHeight; // force reflow
            $header.classList.add('visible');
            window.headerState.visible = true;
            document.body.classList.add('hdr-stick');

            setTimeout(function() {
                window.headerState.animating = false;
                if (window.headerState.sticky) {
                    window.dispatchEvent(new CustomEvent('headerStateChange', {
                        detail: {
                            top: $header.offsetHeight
                        }
                    }));
                }
            }, 300);
        }
    }

    function hideHeader() {
        if (!window.headerState.animating && $header) {
            window.headerState.animating = true;
            window.removeEventListener('scroll', gHdrScrl);

            if (!$header.classList.contains('slide-in')) {
                $header.classList.add('slide-in');
            }

            $header.classList.remove('visible');
            window.headerState.visible = false;
            document.body.classList.remove('hdr-stick');

            setTimeout(function() {
                window.headerState.animating = false;

                var headerRowBottom = document.querySelector('.header-row-bottom');
                var searchIcon = document.querySelector('.header-search-icon');
                if (headerRowBottom) {
                    headerRowBottom.classList.remove('active');
                }
                if (searchIcon) {
                    searchIcon.classList.remove('active');
                }
                document.body.classList.remove('hdr-expand');

                if (window.headerState.sticky) {
                    window.dispatchEvent(new CustomEvent('headerStateChange', {
                        detail: {
                            top: 0
                        }
                    }));
                }
            }, 300);

            setTimeout(function() {
                window.addEventListener('scroll', gHdrScrl);
            }, 650);
        }
    }

    var ticking = false;
    window.gHdrScrl = function() {
        if (!ticking) {
            requestAnimationFrame(function() {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    };

    function initFooterTabs() {
        function switchTab(tab) {
            var allTabs = document.querySelectorAll('.footer-tabs li');
            allTabs.forEach(function(t) {
                t.classList.remove('selected');
            });

            tab.classList.add('selected');

            var sectionToShow = tab.getAttribute('data-section');

            var allSections = document.querySelectorAll('.footer-section');
            allSections.forEach(function(section) {
                section.style.display = 'none';
            });

            var selectedSection = document.querySelector('.section-' + sectionToShow);
            if (selectedSection) {
                selectedSection.style.display = 'flex';
            }
        }

        var minSwipeDistance = 10;
        var touchStartX = 0;
        var touchStartY = 0;
        var touchStartEl = null;
        var touchStartTime = 0;
        var maxTapDuration = 200;
        var isScrolling = false;

        document.addEventListener('touchmove', function() {
            isScrolling = true;
        });

        var footerTabs = document.querySelectorAll('.footer-tabs li');
        footerTabs.forEach(function(tab) {
            tab.addEventListener('click', function(e) {
                if (!isScrolling) {
                    switchTab(this);
                }
                setTimeout(function() {
                    isScrolling = false;
                }, 100);
            });

            tab.addEventListener('touchstart', function(e) {
                touchStartX = e.touches[0].clientX;
                touchStartY = e.touches[0].clientY;
                touchStartEl = this;
                touchStartTime = new Date().getTime();
                isScrolling = false;
            });

            tab.addEventListener('touchend', function(e) {
                var touchEndTime = new Date().getTime();
                var touchDuration = touchEndTime - touchStartTime;

                var touchEndX = e.changedTouches[0].clientX;
                var touchEndY = e.changedTouches[0].clientY;

                var distX = Math.abs(touchEndX - touchStartX);
                var distY = Math.abs(touchEndY - touchStartY);

                if (distX > minSwipeDistance || distY > minSwipeDistance) {
                    isScrolling = true;
                }
            });

            tab.addEventListener('mouseenter', function() {
                if (!('ontouchstart' in window) && !window.matchMedia('(pointer: coarse)').matches) {
                    switchTab(this);
                }
            });
        });
    }

    // ============================================================================
    // LANGUAGE EDITIONS DROPDOWN
    // ============================================================================

    function initLanguageEditions() {
        var univadisMap = {
            'fr': {
                'leaveMsg': 'Vous allez maintenant quitter Medscape pour consulter plus d\'actualités médicales françaises sur notre site partenaire Univadis.',
                'loginMsg': 'Vous souhaitez lire davantage d\'actualités médicales en français ? Découvrez l\'édition française de notre site partenaire Univadis.',
                'lang': 'Français',
                'langEn': 'French',
                'contBtnMsg': 'Continuer sur Univadis',
                'retBtnMsg': 'Revenir sur Medscape',
                'isNew': true,
                'loginEnable': false
            },
            'it': {
                'leaveMsg': 'Stai uscendo da Medscape per visualizzare le ultime notizie mediche italiane dal nostro sito partner, Univadis.',
                'loginMsg': 'Sei interessato a leggere le ultime notizie mediche italiane? Scopri la nostra edizione italiana sul nostro sito partner, Univadis.',
                'lang': 'Italiano',
                'langEn': 'Italian',
                'contBtnMsg': 'Continua verso Univadis',
                'retBtnMsg': 'Ritorna a Medscape',
                'isNew': true,
                'loginEnable': true
            }
        };

        var currCtry = null;
        var langMenuOpen = false;
        var loginRegFlag = false;
        var loggedInSess = ((typeof s_auth_channel_id == 'string' && s_auth_channel_id.indexOf('104') == 0) || (typeof PageMetadata != 'undefined' && typeof PageMetadata.authVar != 'undefined' && typeof PageMetadata.authVar.authenticationChannel != 'undefined' && PageMetadata.authVar.authenticationChannel.toString() == '104'));
        var userCtryApplies = ((typeof s_user_origin == 'string' && typeof univadisMap[s_user_origin.trim()] != 'undefined') || (typeof PageMetadata != 'undefined' && typeof PageMetadata.userSegVars != 'undefined' && typeof PageMetadata.userSegVars.ct != 'undefined' && typeof univadisMap[PageMetadata.userSegVars.ct.trim()] != 'undefined'));

        function closeLangMenu() {
            langMenuOpen = false;
            var headerEdition = document.querySelector('.header-edition');
            if (headerEdition) {
                headerEdition.classList.remove('active');
            }
            document.removeEventListener('click', menuClickOut);
            if (typeof wmdPageLink !== 'undefined') {
                wmdPageLink('hd-gl_langclose', headerEdition);
            }
        }

        function openLangMenu() {
            langMenuOpen = true;
            var headerEdition = document.querySelector('.header-edition');
            if (headerEdition) {
                headerEdition.classList.add('active');
            }
            document.addEventListener('click', menuClickOut);
            if (typeof wmdPageLink !== 'undefined') {
                wmdPageLink('hd-gl_langopen', headerEdition);
            }
        }

        function menuClickOut(e) {
            if (!e.target.classList.contains('header-edition') &&
                !e.target.classList.contains('header-edition-link') &&
                langMenuOpen) {
                closeLangMenu();
            }
        }

        var headerTabsMore = document.querySelectorAll('.header-tab--more, .user-links');
        headerTabsMore.forEach(function(tab) {
            if (!tab.classList.contains('header-edition')) {
                tab.addEventListener('click', function() {
                    var headerEdition = document.querySelector('.header-edition');
                    if (headerEdition) {
                        headerEdition.classList.remove('active');
                    }
                });
            }
        });

        function layerCookie() {
            if (loginRegFlag && document.cookie.indexOf('uni-msg-shown') == -1) {
                loginRegFlag = false;
                var cookExpDate = new Date();
                cookExpDate.setDate(cookExpDate.getDate() + 30);
                cookExpDate = cookExpDate.toUTCString();
                document.cookie = 'uni-msg-shown=true; path=/; domain=medscape.com; expires=' + cookExpDate;
            }
        }

        var headerEdition = document.querySelector('.header-edition');
        if (headerEdition) {
            headerEdition.addEventListener('click', function(e) {
                e.stopPropagation();
                if (this.classList.contains('active')) {
                    closeLangMenu();
                } else {
                    openLangMenu();
                }
            });
        }

        // Dynamically add Univadis links
        var editionsUnivadisList = document.querySelector('.editions-univadis .editions-list');
        var mobileMenuUnivadisList = document.querySelector('.mobile-menu-item-wrap.univadis');

        Object.keys(univadisMap).forEach(function(key) {
            var isNewLabel = '';
            if (univadisMap[key].isNew) {
                isNewLabel = ' <span class="label-new">New</span>';
            }
            
            if (editionsUnivadisList) {
                var li = document.createElement('li');
                li.className = key;
                li.innerHTML = '<a class="external" href="javascript:void(0);" onclick="wmdPageLink(\'hd-gl_u' + key + '\', this);">' + univadisMap[key].lang + isNewLabel + '</a>';
                editionsUnivadisList.appendChild(li);
            }

            if (mobileMenuUnivadisList) {
                var div = document.createElement('div');
                div.className = 'mobile-menu-item';
                div.innerHTML = '<a class="' + key + ' external" href="javascript:void(0);" onclick="wmdPageLink(\'hd-gl_u' + key + '\', this);">' + univadisMap[key].lang + isNewLabel + '</a>';
                mobileMenuUnivadisList.appendChild(div);
            }
        });

        // Univadis link bindings
        var univadisLinks = document.querySelectorAll('.editions-univadis .editions-list li, .mobile-menu-item-wrap.univadis .mobile-menu-item a');
        univadisLinks.forEach(function(link) {
            link.addEventListener('click', function() {
                currCtry = this.className.replace(' external', '');
                var leavingEdition = document.querySelector('.leaving-edition');
                if (leavingEdition) {
                    var descLang = leavingEdition.querySelector('.description.lang');
                    var descEn = leavingEdition.querySelector('.description.en');
                    var continueBtn = leavingEdition.querySelector('.continue');
                    var returnBtn = leavingEdition.querySelector('.return');
                    
                    if (descLang) {
                        descLang.innerHTML = univadisMap[currCtry].leaveMsg;
                    }
                    if (descEn) {
                        descEn.innerHTML = 'You are now leaving Medscape to view the latest ' + univadisMap[currCtry].langEn + ' medical news from our partner site, Univadis.';
                    }
                    if (continueBtn) {
                        continueBtn.innerHTML = univadisMap[currCtry].contBtnMsg;
                    }
                    if (returnBtn) {
                        returnBtn.innerHTML = univadisMap[currCtry].retBtnMsg;
                    }
                    
                    leavingEdition.classList.add('active');
                }
                
                var greyoutLayer = document.querySelector('.greyout-layer');
                if (greyoutLayer) {
                    greyoutLayer.classList.add('active');
                }
            });
        });

        // Exit layer continue/cancel click bindings
        var leavingContinue = document.querySelector('.leaving-edition .continue');
        if (leavingContinue) {
            leavingContinue.addEventListener('click', function() {
                layerCookie();
                if (typeof wmdPageLink !== 'undefined') {
                    wmdPageLink('le-uni' + currCtry + '_cont', this);
                }
                var domain = '';
                if (typeof getDomain === 'function') {
                    if (getDomain().indexOf('dev') != -1) {
                        domain = 'devint.';
                    } else if (getDomain().indexOf('qa') != -1) {
                        domain = 'qa.';
                    } else if (getDomain().indexOf('staging') != -1) {
                        domain = 'staging.';
                    }
                } else if (document.domain.indexOf('dev') != -1) {
                    domain = 'devint.';
                } else if (document.domain.indexOf('qa') != -1) {
                    domain = 'qa.';
                } else if (document.domain.indexOf('staging') != -1) {
                    domain = 'staging.';
                }
                window.location.href = 'https://www.' + domain + 'univadis.' + currCtry;
            });
        }

        var leavingReturn = document.querySelectorAll('.leaving-edition .return, .leaving-edition .close-btn');
        leavingReturn.forEach(function(btn) {
            btn.addEventListener('click', function() {
                layerCookie();
                if (this.classList.contains('close-btn')) {
                    if (typeof wmdPageLink !== 'undefined') {
                        wmdPageLink('le-uni' + currCtry + '_close', this);
                    }
                } else {
                    if (typeof wmdPageLink !== 'undefined') {
                        wmdPageLink('le-uni' + currCtry + '_medsc', this);
                    }
                }
                var greyoutLayer = document.querySelector('.greyout-layer');
                var leavingEdition = document.querySelector('.leaving-edition');
                if (greyoutLayer) {
                    greyoutLayer.classList.remove('active');
                }
                if (leavingEdition) {
                    leavingEdition.classList.remove('active');
                }
            });
        });

        // Login layer display
        if ((loggedInSess || location.search.indexOf('reg=1') != -1) && userCtryApplies && document.cookie.indexOf('uni-msg-shown') == -1 && document.domain.indexOf('medscape.org') == -1) {
            if (typeof s_user_origin == 'string') {
                currCtry = s_user_origin.trim();
            } else if (typeof PageMetadata !== 'undefined' && typeof PageMetadata.userSegVars !== 'undefined') {
                currCtry = PageMetadata.userSegVars.ct.trim();
            }
            
            if (currCtry && univadisMap[currCtry] && univadisMap[currCtry].loginEnable) {
                loginRegFlag = true;
                var leavingEdition = document.querySelector('.leaving-edition');
                if (leavingEdition) {
                    var descLang = leavingEdition.querySelector('.description.lang');
                    var continueBtn = leavingEdition.querySelector('.continue');
                    var returnBtn = leavingEdition.querySelector('.return');
                    
                    if (descLang) {
                        descLang.innerHTML = univadisMap[currCtry].loginMsg;
                    }
                    if (continueBtn) {
                        continueBtn.innerHTML = univadisMap[currCtry].contBtnMsg;
                    }
                    if (returnBtn) {
                        returnBtn.innerHTML = univadisMap[currCtry].retBtnMsg;
                    }
                    
                    leavingEdition.classList.add('active');
                }
                
                var greyoutLayer = document.querySelector('.greyout-layer');
                if (greyoutLayer) {
                    greyoutLayer.classList.add('active');
                }
                
                if (typeof wmdPageLink !== 'undefined') {
                    wmdPageLink('le-uni' + currCtry + '_loglayer');
                }
            }
        }
    }

    // ============================================================================
    // INITIALIZATION
    // ============================================================================

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initHeaderFunctionality();
            initLanguageEditions();
        });
    } else {
        initHeaderFunctionality();
        initLanguageEditions();
    }

    window.changeSeachDB = changeSeachDB;
    window.subsearchheadertrack = subsearchheadertrack;
    window.GenPVID = function() {
        // getting the date, getting the seconds from epoch
        var timestamp = new Date().getTime() / 1000;
        //Rounding the decimal off
        var epochSec = Math.round(timestamp).toString();
        // making an 8 digit random number
        var randomNumber = Math.random().toString().substr(2, 8);
        // set the global variable to the 19 digit page view id
        var tempPVIDreturn = epochSec + randomNumber;

        s_pageview_id = tempPVIDreturn;
        
        document.dispatchEvent(new CustomEvent("pvidReset"));
    };

})();